module.exports = __webpack_public_path__ + "img/powered-by-payje-light.cf0a135a.svg";